declare const dataLayer: unknown[] | undefined;

export function gtmEvent(evt: unknown) {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(evt);
  }
}
